const animationGalleryRevealEffect = () => {
	const titles = gsap.utils.toArray('.gallery-title');
	const pictures = gsap.utils.toArray('.gallery-figure');

	if (titles.length) {
		titles.forEach((title) => {
			gsap.set(title, { y: 60 });

			ScrollTrigger.create({
				trigger: title,
				onEnter: () =>
					gsap.to(title, {
						duration: 0.45,
						y: 0,
						opacity: 1,
						ease: 'power2.out',
					}),
			});
		});
	}

	if (pictures.length) {
		gsap.set(pictures, { y: 50 });

		ScrollTrigger.batch(pictures, {
			batchMax: 4,
			onEnter: (batch) =>
				gsap.to(batch, {
					duration: 0.35,
					delay: 0.5,
					opacity: 1,
					y: 0,
					stagger: 0.2,
					overwrite: true,
				}),
		});
	}
};

export default animationGalleryRevealEffect;
